import { gsap } from "gsap";

export default () => {

    // <body id="home">
    const section = document.body.id;
    gsap.set("body", {opacity: 1});
    
    // Map page names for dynamic imports
    const pages = {
        home:           import('./pages/home'),
        senseiPhong:    import('./pages/sensei-phong'),
        about:           import('./pages/about'),
        osensei:           import('./pages/osensei'),
        //product:        import('./pages/product'),
        //team:           import('./pages/team'),
    }
    
    async function renderPage(name) {
        //
        // Lazily load the requested page.
        const page = await pages[name]
        return page.render()
    }

    renderPage(section);
}